import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const transactionTypeLocaleModule: LocaleModule = {
  name: "transactionType",
  messages: { en: en, it: it },
};
